import { render } from "./DataTable.vue?vue&type=template&id=c202f870&scoped=true"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"

import "./DataTable.vue?vue&type=style&index=0&id=c202f870&scoped=true&lang=css"

import exportComponent from "D:\\Documentos\\Cliqx\\worsapace_cliqx\\interagev2\\facilitabots.interagev2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c202f870"]])

export default __exports__